var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAir(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "air"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2191_1077",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 34,
    height: 34
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    width: 34,
    height: 34,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2191_1077)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "air_2",
    d: "M16.2904 28.3333C15.1098 28.3333 14.1063 27.9201 13.2799 27.0938C12.4536 26.2674 12.0404 25.2639 12.0404 24.0833H14.8737C14.8737 24.4847 15.0095 24.8212 15.281 25.0927C15.5525 25.3642 15.889 25.5 16.2904 25.5C16.6918 25.5 17.0282 25.3642 17.2997 25.0927C17.5713 24.8212 17.707 24.4847 17.707 24.0833C17.707 23.6819 17.5713 23.3455 17.2997 23.074C17.0282 22.8024 16.6918 22.6667 16.2904 22.6667H2.83203V19.8333H16.2904C17.4709 19.8333 18.4744 20.2465 19.3008 21.0729C20.1272 21.8993 20.5404 22.9028 20.5404 24.0833C20.5404 25.2639 20.1272 26.2674 19.3008 27.0938C18.4744 27.9201 17.4709 28.3333 16.2904 28.3333ZM2.83203 14.1667V11.3333H21.957C22.5709 11.3333 23.0786 11.1326 23.4799 10.7313C23.8813 10.3299 24.082 9.82222 24.082 9.20833C24.082 8.59444 23.8813 8.08681 23.4799 7.68542C23.0786 7.28403 22.5709 7.08333 21.957 7.08333C21.3431 7.08333 20.8355 7.28403 20.4341 7.68542C20.0327 8.08681 19.832 8.59444 19.832 9.20833H16.9987C16.9987 7.81528 17.4768 6.64063 18.4331 5.68438C19.3893 4.72813 20.564 4.25 21.957 4.25C23.3501 4.25 24.5247 4.72813 25.481 5.68438C26.4372 6.64063 26.9154 7.81528 26.9154 9.20833C26.9154 10.6014 26.4372 11.776 25.481 12.7323C24.5247 13.6885 23.3501 14.1667 21.957 14.1667H2.83203ZM26.207 25.5V22.6667C26.8209 22.6667 27.3286 22.466 27.7299 22.0646C28.1313 21.6632 28.332 21.1556 28.332 20.5417C28.332 19.9278 28.1313 19.4201 27.7299 19.0188C27.3286 18.6174 26.8209 18.4167 26.207 18.4167H2.83203V15.5833H26.207C27.6001 15.5833 28.7747 16.0615 29.731 17.0177C30.6872 17.974 31.1654 19.1486 31.1654 20.5417C31.1654 21.9347 30.6872 23.1094 29.731 24.0656C28.7747 25.0219 27.6001 25.5 26.207 25.5Z",
    fill: "#FE6728"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAir);
export default __webpack_public_path__ + "static/media/air.2d8f00fc4bb8c3fb6546b13d61a6ff19.svg";
export { ForwardRef as ReactComponent };